import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import translate from './TranslateHOC';
import {
  SHARE_DIALOG,
  SUBTITLE_ID_CY,
  SUBTITLE_ID_EN,
  SHORTCUT_DIALOG,
} from '../constants';
import { programmeTitle, isIos9, IsvgWrapper } from '../helpers';
import AutoplayNext from './AutoplayNext';
import ProgrammeWarning from './ProgrammeWarning';
import ProgSignUpModal from './ProgSignUpModal';
import AddToList from './AddToList';
import Isvg from 'react-inlinesvg';
import clic_play_lock from '../img/icons/clic_play_lock.svg';
import { fetchProgrammePodcasts } from '../actions';
import IsLoadingAnim from './alerts/IsLoadingAnim';
import tv from '../img/icons/tv.svg';
import alarm from '../img/icons/alarm.svg';
import timer from '../img/icons/timer.svg';
import subtitles from '../img/icons/subtitles.svg';
import chat_bubble from '../img/icons/chat_bubble.svg';
import { show } from 'redux-modal';
import { bindActionCreators } from 'redux';
import ShareDialog from './player/modals/ShareDialog';
import ShortcutDialog from './player/modals/ShortcutDialog';
import { Button as ButtonV2 } from '../v2/components/button/Button';
import { Icon as IconV2 } from '../v2/components/icon/Icon';

const ProgrammeMeta = (props) => {
  const { strings, prog, toggleShortcut } = props;
  let subtitlesStr = null;

  // sort out string for subtitle availability
  if (prog) {
    if (prog.subtitle_e) {
      subtitlesStr = strings.englishSubtitles;
    }
    if (prog.subtitle_c) {
      subtitlesStr = strings.welshSubtitles;
    }
    if (prog.subtitle_c && prog.subtitle_e) {
      subtitlesStr = strings.welshEnglishSubtitles;
    }
  }

  return (
    <div className="programme__meta">
      <ul className="programme__meta-list">
        <li className="programme__meta-duration">
          <span className="programme__meta-icon">
            <IsvgWrapper addClasses='icon'>
              <Isvg src={timer} />
            </IsvgWrapper>
          </span>
          <span>
            {prog.duration} {strings.minutes}
          </span>
        </li>
        <li className="programme__meta-days">
          <span className="programme__meta-icon">
            <IsvgWrapper addClasses='icon'>
              <Isvg src={alarm} />
            </IsvgWrapper>
          </span>
          <span>
            {strings.expiresIn} {prog.days_to_expire} {strings.days}
          </span>
        </li>
        <li className="programme__meta-aired">
          <span className="programme__meta-icon">
            <IsvgWrapper addClasses='icon'>
              <Isvg src={tv} />
            </IsvgWrapper>
          </span>
          <span>
            {strings.firstAiredOn} {prog.clic_aired}
          </span>
        </li>
        {subtitlesStr && (
          <li className="programme__meta-subtitles">
            <span className="programme__meta-icon">
              <IsvgWrapper addClasses='icon'>
                <Isvg src={subtitles} />
              </IsvgWrapper>
            </span>{' '}
            <span>{subtitlesStr}</span>
          </li>
        )}
        {prog && prog.audio_description && (
          <li className="programme__meta-subtitles">
            <span className="programme__meta-icon">
              <IsvgWrapper addClasses='icon'>
                <Isvg className="icon" src={chat_bubble} />
              </IsvgWrapper>
            </span>{' '}
            <span>{strings.audioDescribed}</span>
          </li>
        )}
        <li className="programme__meta-shortcuts">
          <span className="programme__meta-icon">
            <IconV2 materialLabel="keyboard" type="material" />
          </span>
          <ShortCutButtonContainer>
            <ButtonV2
              onClick={toggleShortcut}
              label={strings.keyboardShortcuts}
              size="medium"
              type="tertiary"
            />
          </ShortCutButtonContainer>
          <ShortcutDialog strings={strings} />
        </li>
      </ul>
    </div>
  );
};

const ProgrammePodcasts = (props) => {
  const { strings, podcastsItems, podcastsIsLoading } = props;

  if (podcastsIsLoading) {
    return <IsLoadingAnim />;
  }

  return (
    <div className="podcast-links">
      <h4 className="podcast-links__title">{strings.podcasts}</h4>
      <ul className="podcast-links__list">
        {podcastsItems &&
          podcastsItems.length > 0 &&
          Object.keys(podcastsItems).map((key) => (
            <li key={key} className="podcast-links__item">
              <a href={podcastsItems[key].link} className="podcast-links__link">
                {podcastsItems[key].title}
              </a>
            </li>
          ))}
      </ul>
    </div>
  );
};

class ProgrammeDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggle: false,
      showSignUp: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleUnsuitable = this.handleUnsuitable.bind(this);
    this.handleShare = this.handleShare.bind(this);
  }

  componentDidMount = () => {
    this.props.fetchProgrammePodcasts(
      this.props.prog.id,
      this.props.prog.series_id
    );
  };

  handleClick(e) {
    this.setState({ isToggle: !this.state.isToggle });
  }

  handleUnsuitable(e) {
    //this.playThis = setTimeout(() => this.props.handleUnsuitable(), 2000);
    this.props.handleUnsuitable();
  }

  toggleLoginPrompt = (e) => {
    this.setState({ showSignUp: !this.state.showSignUp });
  };

  handleButtonToggleSigned = (event) => {
    if (event.charCode === 32 || event.charCode === 13) {
      this.props.toggleSigned();
    }
  };

  handleUpdateSubtitleId = (event, type) => {
    if (event.charCode === 32 || event.charCode === 13) {
      this.props.updateSubtitleId(event, type, true);
    }
  };

  handleShare(e) {
    this.props.show(SHARE_DIALOG, {});
  }

  handleShareKeyboard = (event) => {
    if (event.charCode === 32 || event.charCode === 13) {
      this.handleShare();
    }
  };

  toggleShortcutPrompt = (e) => {
    this.props.show(SHORTCUT_DIALOG, {});
  };

  showSignedOption(available, signed) {
    const signedCheckBox =
      (parseInt(signed, 10) === 1 && available) ||
      (parseInt(signed, 10) !== 1 && available)
        ? true
        : false;
    const signedIcon =
      parseInt(signed, 10) === 1 ? 'check_box' : 'check_box_outline_blank';
    const tooltip = this.props.strings.signedVersion;

    if (signedCheckBox) {
      return (
        <>
          <ButtonV2
            onKeyPress={(event) => this.handleButtonToggleSigned(event)}
            onClick={() => this.props.toggleSigned()}
            iconType="material"
            materialLabel={signedIcon}
            icon
            label={tooltip}
            size="small"
            type="secondary"
            data-tip={tooltip}
            tabIndex="0"
          />
          <span className="screen-reader-text">{tooltip}</span>
        </>
      );
    }
  }

  showSubtitlesOption(type = false) {
    let tooltip, signedIcon;
    if (type === SUBTITLE_ID_CY) {
      tooltip = this.props.strings.welshSubtitles;
      signedIcon =
        this.props.subtitleId === SUBTITLE_ID_CY
          ? 'check_box'
          : 'check_box_outline_blank';
    } else if (type === SUBTITLE_ID_EN) {
      tooltip = this.props.strings.englishSubtitles;
      signedIcon =
        this.props.subtitleId === SUBTITLE_ID_EN
          ? 'check_box'
          : 'check_box_outline_blank';
    }

    if (type) {
      return (
        <ButtonV2
          onKeyPress={(event) => this.handleUpdateSubtitleId(event, type)}
          onClick={(event) => this.props.updateSubtitleId(event, type, true)}
          iconType="material"
          materialLabel={signedIcon}
          icon
          label={tooltip}
          size="small"
          type="secondary"
          data-tip={tooltip}
          tabIndex="0"
        />
      );
    }
  }

  showShareOption() {
    return (
      <>
        <ButtonV2
          onKeyPress={(event) => this.handleShareKeyboard(event)}
          onClick={(event) => this.handleShare(event)}
          iconType="material"
          materialLabel="share"
          icon
          label={this.props.strings.share}
          size="small"
          type="secondary"
          data-tip={this.props.strings.share}
          tabIndex="0"
        />
        <span className="screen-reader-text">{this.props.strings.share}</span>
      </>
    );
  }

  render() {
    const {
      strings,
      prog,
      signed,
      myList,
      disablePlayBack,
      loginRedirect,
      podcastsItems,
      podcastsIsLoading,
      podcastsHasErrored,
      isUnsuitable,
      isChildLocked,
    } = this.props;
    const progTitles = programmeTitle(
      prog.series_title,
      prog.programme_title,
      prog.clic_aired
    );
    const showSubtitlesC =
      prog.subtitle_c && prog.subtitle_c.length > 0 ? true : false;
    const showSubtitlesE =
      prog.subtitle_e && prog.subtitle_e.length > 0 ? true : false;

    return (
      <div
        className={this.state.showSignUp ? 'programme__sign-up-container' : ''}
      >
        {!disablePlayBack && isUnsuitable && !isChildLocked && (
          <div
            className="programme__play-icon"
            onKeyPress={(event) => {
              if (event.charCode === 32 || event.charCode === 13) {
                this.handleUnsuitable();
              }
            }}
            onClick={this.handleUnsuitable}
            role="button"
            tabIndex={0}
          >
            <IsvgWrapper addClasses='icon'>
              <Isvg src={clic_play_lock}/>
            </IsvgWrapper>
          </div>
        )}
        <ProgrammeWarning prog={prog} isChildLocked={isChildLocked} />
        {/* if user's not auth'ed and has clicked to play, then will get this pseudo-modal */}
        {this.state.showSignUp && (
          <ProgSignUpModal
            toggleThis={this.toggleLoginPrompt}
            loginRedirect={loginRedirect}
          />
        )}
        <ShareDialog trans={strings} prog={prog} />
        <div
          className={
            this.state.showSignUp ? 'programme programme--blur' : 'programme'
          }
        >
          {/* Unsuitable content */}

          {/* takes you to sign up/log in but we need to remember where the user was so they can
							jump straight back here */}
          {/* Unauthenticated */}
          {disablePlayBack && (
            <div
              className="programme__play-icon"
              onKeyPress={(event) => {
                if (event.charCode === 32 || event.charCode === 13) {
                  this.toggleLoginPrompt();
                }
              }}
              onClick={this.toggleLoginPrompt}
              role="button"
              tabIndex={0}
            />
          )}

          <div className="programme__copy">
            <div className="programme__details">
              <div className="programme__verbage">
                <div className="programme__watch">
                  {/* !disablePlayBack && <button className="button-link" onClick={handleWatch}>{strings.watch}</button> */}
                </div>
                <h2 className="programme__title">{progTitles.title}</h2>
                <h3 className="programme__sub-title">{progTitles.subTitle}</h3>
                <div className="programme__billing">{prog.short_billing}</div>
              </div>
              <ProgrammeMeta
                prog={prog}
                strings={strings}
                toggleShortcut={this.toggleShortcutPrompt}
              />
              {podcastsItems &&
                podcastsItems.length > 0 &&
                !podcastsHasErrored && (
                  <ProgrammePodcasts
                    podcastsItems={podcastsItems}
                    podcastsIsLoading={podcastsIsLoading}
                    strings={strings}
                  />
                )}

              <div className="programme__actions">
                <ul className="programme__actions-list">
                  <AddToList id={prog.fav_id} myList={myList} />
                  <li>
                    <AutoplayNext />
                  </li>
                  {!isIos9() && <li>{this.showShareOption()}</li>}
                  {showSubtitlesC && (
                    <li>{this.showSubtitlesOption(SUBTITLE_ID_CY)}</li>
                  )}
                  {showSubtitlesE && (
                    <li>{this.showSubtitlesOption(SUBTITLE_ID_EN)}</li>
                  )}
                  <li>
                    {this.showSignedOption(
                      prog.other_version_available,
                      signed
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const ShortCutButtonContainer = styled.div`
  a {
    padding: 6px 0;
    font-size: 18px;
    text-align: left;
  }
`;

const mapStateToProps = (state) => {
  return {
    podcastsIsLoading: state.podcastsItems.loading,
    podcastsHasErrored: state.podcastsItems.error,
    podcastsItems: state.podcastsItems.success,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProgrammePodcasts: (programme_id, series_id) =>
      dispatch(fetchProgrammePodcasts(programme_id, series_id)),
    show: bindActionCreators(show, dispatch),
  };
};
export default translate(
  connect(mapStateToProps, mapDispatchToProps)(ProgrammeDetails)
);
